import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Savu nin!
    </p>

    <p class="mb-3">
      Ili pereigas niajn infanojn!!!
    </p>

    <p class="mb-3">
      Ili venenigas ilin per sia ϴ-radiado, kaj ni neniel povas protekti nin!
    </p>

    <p class="mb-3">
      Ili estas grandegaj, kiel niaj infanoj, kaj normala homo mezstatura apenaŭ atingas ilian talion; kaj maljunulon ili tute ne rimarkas.
    </p>

    <p class="mb-3">
      Ni neniel povas kontraŭstari. Niaj ѱ- kaj Ѵ-ondoj por ili, verŝajne, ne senteblas; ili estas faritaj el alia substanco, kaj niaj armiloj senpovas kontraŭ ili. 
      Ni perdas niajn infanojn. 
      Ni formortos.
    </p>

    <p class="mb-5">
      Savu nin iu!
    </p>  

      
    <p class="text-center bold mb-3 mt-3">* * *</p>
      

    <p class="mb-3">
      Kosmonaŭtoj revenis al Tero kun trista novaĵo.
    </p>
    
    <p class="mb-3">
      Sur la planedo Zero, kie ili esploris novan homaspektan civilizon, estis trovitaj tre multaj infanoj kaj adoleskuloj, sed preskaŭ neniuj plenkreskaj personoj. 
      Kun la neplenaĝa parto de loĝantaro la esploristoj, kompreneble, kontakti ne celis; kaj plenkreskuloj, kun kiuj ili penis komunikiĝi pere de ϴ-ondaj rektaj emisiiloj, ial al sencohavaj signaloj ne reagis kaj ne sendis respondon.
    </p>
    
    <p class="mb-5">
      Sur la Tero oni decidis, ke tiu civilizo estas ankoraŭ nematura, kaj ne venis tempo ligi kontakton kun ĝi. 
      La kosmoŝipo forflugis.
    </p>  


    <p class="text-center bold mb-3 mt-3">* * *</p> 
      

    <p class="mb-3">
      La planedo estis savita.
    </p>

    <p class="mb-3">
      Ĝiaj loĝantoj povis daŭre vivi kiel vivis, evoluante de grandegaj infanoj, aperantaj pro densigo de materio per la ondoj, kaj poiomete malkreskante, diminuante, kaj en fino de la vivo tute malaperante, dissolviĝante en la oceano de materio, el kiu ili ekestis.
    </p>

    <p class="mb-3">
      Ĉu povas ja ekzisti alia vojo de evoluo?
    </p>
    `
  )
}

const itemName = {
  esp: 'Io pri diverseco'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;